import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

let lenisInstance = null;

export const scrollToSection = (hash, offset = -72) => {
    const id = hash.replace("#", "");
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisInstance) {
        lenisInstance.scrollTo(el, { offset, duration: 1.1 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};

export const scrollToTop = () => {
    if (lenisInstance) {
        lenisInstance.scrollTo(0, { duration: 1.1 });
    } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
};

export default function SmoothScroll({ children }) {
    const location = useLocation();
    const raf = useRef(null);

    useEffect(() => {
        let lenis;
        let cancelled = false;
        const init = async () => {
            const { default: Lenis } = await import("lenis");
            if (cancelled) return;
            lenis = new Lenis({ lerp: 0.1, wheelMultiplier: 1 });
            lenisInstance = lenis;
            const loop = (time) => {
                lenis.raf(time);
                raf.current = requestAnimationFrame(loop);
            };
            raf.current = requestAnimationFrame(loop);
        };
        init();
        return () => {
            cancelled = true;
            if (raf.current) cancelAnimationFrame(raf.current);
            if (lenis) lenis.destroy();
            lenisInstance = null;
        };
    }, []);

    useEffect(() => {
        if (location.hash) {
            const t = setTimeout(() => scrollToSection(location.hash), 450);
            return () => clearTimeout(t);
        }
        if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
        window.scrollTo(0, 0);
    }, [location.pathname, location.hash]);

    return children;
}
